var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-alert',{attrs:{"variant":"success","show":_vm.create,"dismissible":""}},[_vm._v("Doc Created!")]),_c('span',{staticClass:"float-right"},[_c('a',{staticClass:"btn btn-secondary",attrs:{"href":"/doc/create"}},[_vm._v("Create Doc")])]),_c('h1',[_vm._v("Documents")]),_c('DocsList',{attrs:{"list":_vm.docs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }